const modal = document.getElementById("mac-modal");
const openButton = document.getElementById("open-configurator");
const closeButton = document.getElementById("close-configurator");
const addToCartButton = document.getElementById("mac-add-to-cart");

const biothaneLayer = document.getElementById("biothane-layer");
const hardwareLayer = document.getElementById("bouclerie-layer");

// ----------------------------
// Synchronisation popup
// ----------------------------

function syncConfigurator() {

  // Couleur du biothane
  const selectedColor = document.querySelector(
    'input[type="radio"][name^="Couleur du biothane"]:checked'
  );

  if (selectedColor) {

    document.querySelectorAll(".biothane-btn").forEach((btn) => {

      const active = btn.dataset.value === selectedColor.value;

      btn.classList.toggle("active", active);

      if (active) {
        biothaneLayer.src = btn.dataset.image;
      }

    });

  }

  // Bouclerie
  const selectedHardware = document.querySelector(
    'input[type="radio"][name^="Bouclerie"]:checked'
  );

  if (selectedHardware) {

    document.querySelectorAll(".hardware-btn").forEach((btn) => {

      const active = btn.dataset.value === selectedHardware.value;

      btn.classList.toggle("active", active);

      if (active) {
        hardwareLayer.src = btn.dataset.image;
      }

    });

  }

}

// ----------------------------
// Ouverture / fermeture
// ----------------------------

if (openButton) {

  openButton.addEventListener("click", () => {

    syncConfigurator();

    modal.classList.add("active");

  });

}

if (closeButton) {

  closeButton.addEventListener("click", () => {

    modal.classList.remove("active");

  });

}

if (modal) {

  modal.addEventListener("click", (e) => {

    if (e.target === modal) {

      modal.classList.remove("active");

    }

  });

}

// ----------------------------
// Fonction Horizon
// ----------------------------

function selectVariant(optionName, optionValue) {

  const radios = document.querySelectorAll(
    `input[type="radio"][value="${optionValue}"]`
  );

  for (const radio of radios) {

    if (!radio.name.startsWith(optionName)) continue;

    if (radio.checked) return;

    radio.checked = true;

    radio.dispatchEvent(
      new Event("change", {
        bubbles: true
      })
    );

    return;

  }

}

// ----------------------------
// Couleurs
// ----------------------------

document.querySelectorAll(".biothane-btn").forEach((button) => {

  button.addEventListener("click", () => {

    document.querySelectorAll(".biothane-btn").forEach((btn) => {

      btn.classList.toggle("active", btn === button);

    });

    biothaneLayer.src = button.dataset.image;

    selectVariant(
      "Couleur du biothane",
      button.dataset.value
    );

  });

});

// ----------------------------
// Bouclerie
// ----------------------------

document.querySelectorAll(".hardware-btn").forEach((button) => {

  button.addEventListener("click", () => {

    document.querySelectorAll(".hardware-btn").forEach((btn) => {

      btn.classList.toggle("active", btn === button);

    });

    hardwareLayer.src = button.dataset.image;

    selectVariant(
      "Bouclerie",
      button.dataset.value
    );

  });

});

// ----------------------------
// Ajouter au panier
// ----------------------------

if (addToCartButton) {

  addToCartButton.addEventListener("click", () => {

    addToCartButton.disabled = true;
    addToCartButton.textContent = "Ajout en cours...";

    // Bouton officiel Horizon
    const shopifyButton = document.querySelector(
      'button[data-testid="standalone-add-to-cart"]'
    );

    if (!shopifyButton) {

      addToCartButton.disabled = false;
      addToCartButton.textContent = "Ajouter au panier";

      alert("Impossible de trouver le bouton Ajouter au panier.");

      return;

    }

    shopifyButton.click();

    setTimeout(() => {

      addToCartButton.textContent = "✓ Ajouté au panier";

      setTimeout(() => {

        modal.classList.remove("active");

        addToCartButton.disabled = false;
        addToCartButton.textContent = "Ajouter au panier";

      }, 900);

    }, 300);

  });

}